import React, {RefObject, useState, useEffect} from "react";
import {Video, VideoSlide} from "src/common/video/models/Video";
import {VideoCaptionTrack, VideoCaption} from "src/common/video/models/VideoCaption";
import styles from "./ThreeSplitVideoPlayer.module.css";
import {Document, Page, pdfjs} from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "../../../../pages/vod/video/reactPdf.css";
import CaptionsPanel from "./captions/CaptionsPanel";
import {IconButton} from "@material-ui/core";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import VideoCommentPanel from "../comments/VideoCommentPanel";
import VideoSuggestionsPanel from "../suggestions/VideoSuggestionsPanel";
import VideoDocument from "../../../../pages/vod/Common/VideoDocument";
import VideoInfoPanel from "../metaData/VideoInfoPanel";
import EditVideoTab from "src/components/EditVideo";
import PuiMessage from "../../../../components/widgets/PuiMessage";
import PuiTypography from "src/components/elements/PuiTypography";
import VideoPageBar from "./slides/VideoPageBar";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import SlidePlayButton from "src/common/components/images/SlidePlayButton";
import SlidePlayButtonFocus from "src/common/components/images/SlidePlayButtonFocus";
import SlideBackButton from "src/common/components/images/SlideBackButton";
import SlideBackButtonFocus from "src/common/components/images/SlideBackButtonFocus";
import {css} from "@emotion/css";
import VideoReactions from "./reactions/VideoReactions";
import {UpdateVideoOption} from "src/store/actions/ExVideoActions";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


interface ThreeSplitVideoPlayerProps {
  video: Video;
  videoRef: RefObject<HTMLVideoElement>;
  currentVideoTimeMs: number;
  subtitles: VideoCaptionTrack[];
  videoCaptions: VideoCaption[],
  ClickVideo: (event: any) => void;
}

function ThreeSplitVideoPlayer({
    video,
    videoRef,
    currentVideoTimeMs,
    subtitles,
    videoCaptions,
    ClickVideo
}: ThreeSplitVideoPlayerProps) {
    const dispatch = useDispatch();

    const {videoPdf, videoOption} = useSelector(
        (state: AppState) => ({
            videoPdf: state.video.videoPdf,
            videoOption: state.exVideo.videoOption
        })
    );

    // ビデオURL
    const sourceUrl = video.sourceUrl;

    const videoDownloadControl = document.getElementById("videoPlayer");
    if (videoDownloadControl)
        videoDownloadControl.oncontextmenu = function () {
            return false;
        };

    const [msg, setMsg] = React.useState<string>("");
    const closeMsg = () => {
        setMsg("");
    };

    const [slideClicked, setSlideClicked] = useState(false);
    const [isPlayFocus, setIsPlayFocus] = useState<boolean>(false);
    const [isBackFocus, setIsBackFocus] = useState<boolean>(false);
    const [numPages, setNumPages] = useState<number>(1);
    const [clickedPage, setClickPage] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(-1);
    const [videoSlides, setVideoSlides] = useState<VideoSlide[]>([]);

    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    // ビデオの視聴時間を監視(1秒ごと)
    useEffect(() => {
        if (!videoPdf) return;
        changeActiveSlide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVideoTimeMs, videoPdf]);

    // スライド一覧表示フィルダ
    useEffect(() => {
        const tempList = [];
        if (videoPdf?.videoSlides) {
            for (let index = 0; index < videoPdf?.videoSlides.length; index++) {
                const element = videoPdf?.videoSlides[index];
                // スライド時間を設定しているか
                if (element.startMillis >= 0) {
                    tempList.push(element);
                }
            }
            setVideoSlides(tempList);
        }
    }, [videoPdf]);

    // スライド一覧をクリック時
    // const handleChangeSlide = (swiper: any) => {
    //   const currentSlide = swiper.clickedSlide;
    //   if (!currentSlide) return;
    //   const page = currentSlide.firstElementChild;
    //   const pageNum = page.getAttribute("data-page-number");
    //   setSlideClicked(true);
    //   setClickPage(Number(pageNum));
    // };

    // 再生中のスライド設定(1秒ごと)
    function changeActiveSlide() {
        for (let index = 0; index < videoSlides.length; index++) {
            const element = videoSlides[index];
            // 最後の一枚
            if (index + 1 === videoSlides.length) {
                setActivePage(element.slideId);
            }
            // 再生時間と設定時間との比較
            if (currentVideoTimeMs < element.startMillis) {
                // 最初の一枚
                if (index === 0) {
                    setActivePage(1);
                } else {
                    const preNum = videoSlides[index - 1].slideId;
                    setActivePage(preNum);
                }
                break;
            }
        }
    }

    // 再生中のスライドへ移動
    function changeCurrentSlide() {
        for (let index = 0; index < videoSlides.length; index++) {
            const element = videoSlides[index];
            // 最後の一枚
            if (index + 1 === videoSlides.length) {
                setActivePage(element.slideId);
            }
            // 再生時間と設定時間との比較
            if (currentVideoTimeMs < element.startMillis) {
                // 最初の一枚
                if (index === 0) {
                    setActivePage(1);
                    setSlideClicked(false);
                } else {
                    const preNum = videoSlides[index - 1].slideId;
                    setActivePage(preNum);
                    setSlideClicked(false);
                }
                break;
            }
        }
        setSlideClicked(false);
    }

    // スライドに合わせてビデオ秒数を設定
    function changeCurrentTime(slideNum: string) {
        for (let index = 0; index < videoSlides.length; index++) {
            const element = videoSlides[index];
            if (String(element.slideId) === slideNum) {
                console.log("changeCurrentTime:", element.startMillis / 1000);
                setActivePage(element.slideId);
                if (videoRef.current)
                    videoRef.current.currentTime = element.startMillis / 1000;
            }
        }
        setSlideClicked(false);
    }

    // スライド一覧のページ移動
    // function previousPage() {
    //     setClickPage(clickedPage - 1);
    // }
    // function nextPage() {
    //     setClickPage(clickedPage + 1);
    // }
    // スライドエリアの表示
    function handleShowSlide() {
        if (slideClicked) {
            return clickedPage;
        } else {
            if (activePage > 0) return activePage;
            return 1;
        }
    }

    // スイッチ押下で、表示エリア切り替え
    const [isVisibleLeftVideo, ChangeLeftAreaVideo] = useState(true);
    const ClickSwitchAreaButton = () => {
        console.log("ClickSwitchAreaButton start");
        const isPlay = videoRef.current
            ? videoRef.current.paused
                ? false
                : true
            : videoOption.isPlay;
        dispatch(
            UpdateVideoOption(
                isPlay,
                videoOption.isVisibleCaption,
                videoOption.isMuted,
                videoOption.viewPattern
            )
        );
        ChangeLeftAreaVideo(!isVisibleLeftVideo);
        console.log("isVisibleLeftVideo", isVisibleLeftVideo);
    };

    // 視聴時間を保持
    // 3画面の表示エリア切替＆3画面表示に切替
    useEffect(() => {
    // 視聴時間の上書きを防ぐ
        if (videoRef.current && currentVideoTimeMs > 0) {
            videoRef.current.currentTime = Math.floor(currentVideoTimeMs / 1000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisibleLeftVideo]);

    const [heightMode, setHeightMode] = useState(false);

    // function checkHeight(index: number) {
    //   const child = document.getElementById(`page_${index}`)?.firstElementChild;
    //   const canvas = child?.firstElementChild;
    //   const width = canvas?.getAttribute("width");
    //   const height = canvas?.getAttribute("height");
    //   if (Number(height) > Number(width) && !heightMode) {
    //     setHeightMode(true);
    //   }
    // }

    if (!video) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div className={styles.videoArea}>
                <div
                    className={
                        isVisibleLeftVideo ? styles.leftAreaVideo : styles.leftAreaSlide
                    }
                >
                    {isVisibleLeftVideo ? (
                        <div className={css`
                          height: 100%;
                          display: flex;
                          flex-direction: column;
                `}
                        >
                            <div className={
                                css`
                                flex:1;
                                position: relative;
                            `
                            }
                            >
                                {videoOption.isPlay ? (
                                    <video
                                        id="videoPlayer"
                                        width="100%"
                                        height="100%"
                                        className={
                                            css`
                                              position: absolute;
                                              top:0;
                                              right:0;
                                              left:0;
                                              bottom:0;
                                              object-fit: contain;
                                            `
                                        }
                                        controls
                                        disablePictureInPicture
                                        autoPlay
                                        muted={videoOption.isMuted}
                                        ref={videoRef}
                                        key={sourceUrl} // Needed to inform React of source changes.
                                        controlsList="nodownload"
                                        onClick={ClickVideo}
                                    >
                                        <source src={sourceUrl} type="video/mp4"/>
                                        {subtitles.map(subtitle => (
                                            <track
                                                key={subtitle.id}
                                                kind="subtitles"
                                                srcLang={subtitle.srcLang}
                                                label={subtitle.label}
                                                src={subtitle.src}
                                            />
                                        ))}
                                    </video>
                                ) : (
                                    <video
                                        id="videoPlayer"
                                        width="100%"
                                        height="100%"
                                        className={
                                            css`
                                            position: absolute;
                                            top:0;
                                            right:0;
                                            left:0;
                                            bottom:0;
                                            object-fit: contain;
                                          `
                                        }
                                        controls
                                        disablePictureInPicture
                                        muted={videoOption.isMuted}
                                        ref={videoRef}
                                        key={sourceUrl} // Needed to inform React of source changes.
                                        controlsList="nodownload"
                                        onClick={ClickVideo}
                                    >
                                        <source src={sourceUrl} type="video/mp4"/>
                                        {subtitles.map(subtitle => (
                                            <track
                                                key={subtitle.id}
                                                kind="subtitles"
                                                srcLang={subtitle.srcLang}
                                                label={subtitle.label}
                                                src={subtitle.src}
                                            />
                                        ))}
                                    </video>
                                )}
                            </div>

                            {/* ビデオリアクション */}
                            <VideoReactions
                                reactions={video.reactions}
                                videoId={video.id}
                                videoDuration={video.durationMillis}
                                videoRef={videoRef}
                                video={video}
                            />

                            {videoPdf !== undefined && (
                                <VideoPageBar
                                    pdf={videoPdf}
                                    videoSlides={videoSlides}
                                    videoDuration={video.durationMillis}
                                    currentVideoTimeMs={
                                        videoRef.current
                                            ? videoRef.current.currentTime * 1000
                                            : currentVideoTimeMs
                                    }
                                    videoRef={videoRef}
                                />
                            )}

                            <div className={styles.editVideoIcon}>
                                <EditVideoTab video={video}/>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.slideViewArea}>
                            {videoPdf !== undefined && (
                                <Document
                                    file={videoPdf.slideUrl}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    options={{
                                        cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                                        cMapPacked: true
                                    }}
                                >
                                    <Page
                                        pageNumber={handleShowSlide()}
                                        className={
                                            heightMode ? styles.heightMode : styles.slidePdfView
                                        }
                                    />
                                </Document>
                            )}
                            <div
                                className={styles.pdfConArea}
                                style={
                                    slideClicked
                                        ? {visibility: "visible"}
                                        : {visibility: "hidden"}
                                }
                            >
                                <div
                                    className={styles.pdfButtonArea}
                                    onClick={() => changeCurrentSlide()}
                                    onMouseEnter={() => setIsBackFocus(true)}
                                    onMouseLeave={() => setIsBackFocus(false)}
                                >
                                    {!isBackFocus && <SlideBackButton/>}
                                    {isBackFocus && <SlideBackButtonFocus/>}
                                </div>
                                <div
                                    className={styles.pdfButtonArea}
                                    onClick={() => changeCurrentTime(String(clickedPage))}
                                    onMouseEnter={() => setIsPlayFocus(true)}
                                    onMouseLeave={() => setIsPlayFocus(false)}
                                >
                                    {!isPlayFocus && <SlidePlayButton/>}
                                    {isPlayFocus && <SlidePlayButtonFocus/>}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={styles.switchHoverArea}>
                        <IconButton
                            onClick={ClickSwitchAreaButton}
                            style={{backgroundColor: "white"}}
                            className={styles.switchAreaButton}
                        >
                            <SwapHorizIcon
                                style={{color: "var(--red)", height: "35px", width: "35px"}}
                            />
                        </IconButton>
                    </div>
                </div>
                <div className={styles.rightArea}>
                    <div className={styles.caption}>
                        <CaptionsPanel
                            videoId={video.id}
                            captions={videoCaptions}
                            videoRef={videoRef}
                            currentVideoTimeMs={currentVideoTimeMs}
                        />
                    </div>
                    <div
                        className={
                            isVisibleLeftVideo
                                ? styles.switchAreaSlide
                                : styles.switchAreaVideo
                        }
                    >
                        {isVisibleLeftVideo ? (
                            <div
                                style={{
                                    minWidth: "100%",
                                    minHeight: "100%",
                                    borderTop: "1px solid var(--gray-85)"
                                }}
                            >
                                {videoPdf !== undefined && (
                                    <Document
                                        file={videoPdf.slideUrl}
                                        onLoadSuccess={onDocumentLoadSuccess}
                                        options={{
                                            cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                                            cMapPacked: true
                                        }}
                                    >
                                        <Page
                                            pageNumber={handleShowSlide()}
                                            className={styles.pdfView}
                                        />
                                    </Document>
                                )}
                                <div
                                    className={styles.pdfConArea}
                                    style={
                                        slideClicked
                                            ? {visibility: "visible"}
                                            : {visibility: "hidden"}
                                    }
                                >
                                    <div
                                        className={styles.pdfButtonArea}
                                        onClick={() => changeCurrentSlide()}
                                        onMouseEnter={() => setIsBackFocus(true)}
                                        onMouseLeave={() => setIsBackFocus(false)}
                                    >
                                        {!isBackFocus && <SlideBackButton/>}
                                        {isBackFocus && <SlideBackButtonFocus/>}
                                    </div>
                                    <div
                                        className={styles.pdfButtonArea}
                                        onClick={() => changeCurrentTime(String(clickedPage))}
                                        onMouseEnter={() => setIsPlayFocus(true)}
                                        onMouseLeave={() => setIsPlayFocus(false)}
                                    >
                                        {!isPlayFocus && <SlidePlayButton/>}
                                        {isPlayFocus && <SlidePlayButtonFocus/>}
                                    </div>
                                </div>
                            </div>
                        ) : (
                        // <div className={css`height: 100%`}>
                            videoOption.isPlay ? (
                                <video
                                    id="videoPlayer"
                                    className={
                                        css`
                              height: 100%;
                              width: 100%;
                              object-fit: contain;
                            `
                                    }
                                    controls
                                    autoPlay
                                    disablePictureInPicture
                                    muted={videoOption.isMuted}
                                    width="100%"
                                    ref={videoRef}
                                    key={sourceUrl} // Needed to inform React of source changes.
                                    controlsList="nodownload"
                                    style={{display: "block"}}
                                    onClick={ClickVideo}
                                >
                                    <source src={sourceUrl} type="video/mp4"/>
                                </video>
                            ) : (
                                <video
                                    id="videoPlayer"
                                    className={
                                        css`
                              height: 100%;
                              width: 100%;
                              object-fit: contain;
                            `
                                    }
                                    controls
                                    disablePictureInPicture
                                    muted={videoOption.isMuted}
                                    width="100%"
                                    ref={videoRef}
                                    key={sourceUrl} // Needed to inform React of source changes.
                                    controlsList="nodownload"
                                    style={{display: "block"}}
                                    onClick={ClickVideo}
                                >
                                    <source src={sourceUrl} type="video/mp4"/>
                                </video>
                            )
                        // </div>
                        )}
                    </div>
                </div>
            </div>
            {/*<div className={styles.slideArea}>*/}
            {/*  {videoPdf !== undefined && (*/}
            {/*    <Document*/}
            {/*      file={videoPdf.slideUrl}*/}
            {/*      onLoadSuccess={onDocumentLoadSuccess}*/}
            {/*      options={{*/}
            {/*        cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,*/}
            {/*        cMapPacked: true,*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      <div>*/}
            {/*        <Swiper*/}
            {/*          spaceBetween={5}*/}
            {/*          slidesPerView={5}*/}
            {/*          loop={false}*/}
            {/*          navigation={{*/}
            {/*            nextEl: ".swiper-button-next",*/}
            {/*            prevEl: ".swiper-button-prev",*/}
            {/*          }}*/}
            {/*          onClick={(swiper) => {*/}
            {/*            handleChangeSlide(swiper);*/}
            {/*          }}*/}
            {/*          initialSlide={activePage}*/}
            {/*        >*/}
            {/*          {videoSlides.map((el, index) => (*/}
            {/*            <SwiperSlide*/}
            {/*              id={`page_${index + 1}`}*/}
            {/*              key={`recordSlide-${index}`}*/}
            {/*              className={*/}
            {/*                el.slideId === activePage ? styles.slideActive : ""*/}
            {/*              }*/}
            {/*            >*/}
            {/*              <Page*/}
            {/*                key={`page_${index + 1}`}*/}
            {/*                pageNumber={el.slideId}*/}
            {/*                className={*/}
            {/*                  slideClicked && el.slideId === clickedPage*/}
            {/*                    ? styles.slideClicked*/}
            {/*                    : styles.slideImg*/}
            {/*                }*/}
            {/*                onRenderSuccess={() => checkHeight(index + 1)}*/}
            {/*              />*/}
            {/*            </SwiperSlide>*/}
            {/*          ))}*/}
            {/*          /!* 送りボタン *!/*/}
            {/*          <div*/}
            {/*            style={{ height: "100%", top: "10%" }}*/}
            {/*            className="swiper-button-prev swiper-button-white"*/}
            {/*            onClick={previousPage}*/}
            {/*          ></div>*/}
            {/*          <div*/}
            {/*            style={{ height: "100%", top: "10%" }}*/}
            {/*            className="swiper-button-next swiper-button-white"*/}
            {/*            onClick={nextPage}*/}
            {/*          ></div>*/}
            {/*        </Swiper>*/}
            {/*      </div>*/}
            {/*    </Document>*/}
            {/*  )}*/}
            {/*</div>*/}
            <div className={styles.menu}>
                {isVisibleLeftVideo && (
                    <VideoMenu video={video} setMsg={setMsg}/>
                )}
            </div>

            <div className={styles.meta}>
                <div className={styles.metaLeft}>
                    <VideoInfoPanel video={video}/>

                    <div className={styles.materials}>
                        <VideoDocument documentList={video.extraMaterials}/>
                    </div>

                    <div className={styles.comments}>
                        <VideoCommentPanel
                            comments={video.comments}
                            videoId={video.id}
                            videoRef={videoRef}
                        />
                    </div>
                </div>
                <div className={styles.metaRight}>
                    <VideoSuggestionsPanel videoId={video.id}/>
                </div>

                <PuiMessage
                    open={msg !== ""}
                    type="success"
                    title="登録に成功しました"
                    detail={[<PuiTypography key={msg}>{msg}</PuiTypography>]}
                    duration={6000}
                    onClose={closeMsg}
                />
            </div>
        </>
    );
}

export default ThreeSplitVideoPlayer;
